import { render, staticRenderFns } from "./cModalViewEmployee.vue?vue&type=template&id=4b6b6464"
import script from "./cModalViewEmployee.vue?vue&type=script&lang=js"
export * from "./cModalViewEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports